const overlay = {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 10
};

export const listPopupStyles = {
  overlay,
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    width: '600px',
    border: 'none',
    borderRadius: '0',
    padding: '0'
  }
};

export const generalPopupStyles = {
  overlay,
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    border: '1px solid #797979',
    width: '366px'
  }
};

export const taskElementStyles = {
  overlay,
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    width: '840px',
    border: 'none',
    borderRadius: '0',
    padding: '0'
  }
};
